"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _startCase = _interopRequireDefault(require("lodash/startCase"));
var _styles = _interopRequireDefault(require("./styles"));
const ProviderBadge = _ref => {
  let {
    badge
  } = _ref;
  const badgeMessageDescriptor = {
    id: `provider.badge.${badge}`,
    defaultMessage: (0, _startCase.default)(badge),
    description: 'Badge text for the specified field'
  };
  return /*#__PURE__*/_react.default.createElement(_styles.default, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, badgeMessageDescriptor));
};
var _default = exports.default = ProviderBadge;
ProviderBadge.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderBadge"
};